<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__header__start -->

<!-- #endregion customCode: page-component-html__header__start -->

<!-- Container: Main Container -->
<div class="rappider-container main-container col-12">
  <div class="rappider-component navigation-bar-6">
    <!-- Component: Navigation Bar 6 -->
    <rappider-navigation-bar
      [menu]="navigationBar_6.menu"
      [isMenuVisible]="navigationBar_6.isMenuVisible"
      [brandRouteUrl]="navigationBar_6.brandRouteUrl"
      [brandImage]="navigationBar_6.brandImage"
      [brandText]="navigationBar_6.brandText"
      [isBrandVisible]="navigationBar_6.isBrandVisible"
      [buttons]="navigationBar_6.buttons"
      [dropdowns]="navigationBar_6.dropdowns"
      [togglerIcon]="navigationBar_6.togglerIcon"
      [isSearchable]="navigationBar_6.isSearchable"
      [searchArea]="navigationBar_6.searchArea"
      [cart]="navigationBar_6.cart"
      [drawer]="navigationBar_6.drawer"
      [isCartVisible]="navigationBar_6.isCartVisible"
      [responsiveMenuMode]="navigationBar_6.responsiveMenuMode"
    >
    </rappider-navigation-bar>
  </div>

  <!-- Container: Container 1 -->
  <div class="rappider-container container-1 col-12">
    <!-- Container: Container 2 -->
    <div class="rappider-container container-2 col-3">
      <div class="rappider-component menu-13">
        <!-- Component: Menu 13 -->
        <rappider-menu
          [config]="menu_13.config"
          [isCollapsed]="menu_13.isCollapsed"
          [paddingValue]="menu_13.paddingValue"
          [menuPlacement]="menu_13.menuPlacement"
        >
        </rappider-menu>
      </div>
    </div>

    <!-- Container: Container 3 -->
    <div class="rappider-container container-3 col-9">
      <div>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <!-- Container: Container 4 -->
  <div class="rappider-container container-4 col-12">
    <!-- Container: Container 2 -->
    <div class="rappider-container container-2 col-4">
      <div class="rappider-component">
        <!-- Component: Image 7 -->
        <rappider-image
          [source]="image_7.source"
          [alternateText]="image_7.alternateText"
          [placeholder]="image_7.placeholder"
          [disablePreview]="image_7.disablePreview"
          [borderSettings]="image_7.borderSettings"
          [shadowSettings]="image_7.shadowSettings"
          [paddingSettings]="image_7.paddingSettings"
          [marginSettings]="image_7.marginSettings"
          [customSizeSettings]="image_7.customSizeSettings"
        >
        </rappider-image>
      </div>

      <div class="rappider-component">
        <!-- Component: Paragraph 8 -->
        <rappider-paragraph
          [content]="paragraph_8.content"
          [colorSettings]="paragraph_8.colorSettings"
          [typography]="paragraph_8.typography"
        >
        </rappider-paragraph>
      </div>
    </div>

    <!-- Container: Container 3 -->
    <div class="rappider-container container-3 col-5">
      <!-- Container: Container 5 -->
      <div class="rappider-container container-5 col-12">
        <div class="rappider-component button-list-12">
          <!-- Component: Button List 12 -->
          <rappider-button-list
            [buttons]="buttonList_12.buttons"
            [direction]="buttonList_12.direction"
            [gap]="buttonList_12.gap"
          >
          </rappider-button-list>
        </div>
      </div>

      <!-- Container: Container 6 -->
      <div class="rappider-container container-6 col-12">
        <div class="rappider-component image-14">
          <!-- Component: Image 14 -->
          <rappider-image
            [source]="image_14.source"
            [alternateText]="image_14.alternateText"
            [placeholder]="image_14.placeholder"
            [disablePreview]="image_14.disablePreview"
            [borderSettings]="image_14.borderSettings"
            [shadowSettings]="image_14.shadowSettings"
            [paddingSettings]="image_14.paddingSettings"
            [marginSettings]="image_14.marginSettings"
            [customSizeSettings]="image_14.customSizeSettings"
          >
          </rappider-image>
        </div>

        <div class="rappider-component">
          <!-- Component: Image 11 -->
          <rappider-image
            [source]="image_11.source"
            [alternateText]="image_11.alternateText"
            [placeholder]="image_11.placeholder"
            [disablePreview]="image_11.disablePreview"
            [borderSettings]="image_11.borderSettings"
            [shadowSettings]="image_11.shadowSettings"
            [paddingSettings]="image_11.paddingSettings"
            [marginSettings]="image_11.marginSettings"
            [customSizeSettings]="image_11.customSizeSettings"
          >
          </rappider-image>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__footer__end -->

<!-- #endregion customCode: page-component-html__footer__end -->
